import React from 'react'

const ArrowDown = () => {
  return (
    <div>
        <i style={{ height: '16px', width: '16px' }} className='fa fa-arrow-down'/>
    </div>
  )
}

export default ArrowDown